export default {
  form: {
    versions: {
      label: 'Wersja',
      placeholder: 'Wybierz wersję',
    },
    font_family: {
      label: 'Rodzina czcionek',
    },
    background_color: {
      label: 'Kolor tła',
    },
    promo_frame_primary_color: {
      label: 'Kolor ramki promo',
    },
    promo_frame_discount_label_color: {
      label: 'Kolor rabatu ramki promo',
    },
    vip_members_cta_color: {
      label: 'Kolor CTA członków VIP',
    },
    url_cta_color: {
      label: 'Kolor CTA URL',
    },
    url_color: {
      label: 'Kolor URL',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Wybierz URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    qr_code_border_color: {
      label: 'Kolor obramowania kodu QR',
    },
    qr_code_background_color: {
      label: 'Kolor tła kodu QR',
    },
    footer_background_color: {
      label: 'Kolor tła stopki',
    },
    logo_zoom: {
      label: 'Rozmiar logo',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować naklejki',
  },
};
